<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "@/components/widgets/preloader";
    import { mapGetters,mapActions,mapState } from "vuex"
    import moment from "moment";
    import { ModelListSelect } from "vue-search-select";
    
    /**
     * Advanced table component
     */
    export default {
      page: {
        title: "SellingPrice Changes Report",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
        Loader,
        ModelListSelect,    
      },
      data() {
        return {
          filterTitle:'SellingPrice Changes Report',
          data: {
            datefrom: '',
            dateto: moment(new Date()).format("YYYY-MM-DD"),
            product:''
          },
          currentdate:moment(new Date()).format("YYYY-MM-DD"),
          title: "SellingPrice PriceChanges Report",
          items: [
            {
              text: "Home",
              href: "/",
            },
            {
              text: "SellingPrice Changes Report",
              active: true,
            },
          ],
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
          filteredReport:[],
          pageOptions: [10, 25, 50, 100, 200, 1000],
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          fields: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "product",
              sortable: true,
              label: "PRODUCT",
            },
            {
              key: "old_price",
              sortable: true,
              label: "OLD PRICE",
            },
            {
              key: "new_price",
              sortable: true,
              label: "NEW PRICE",
            },
            {
              key: "recordedby",
              sortable: true,
              label: "RECORDED BY",
            },
            {
              key: "recordedon",
              sortable: true,
              label: "RECORDED ON",
            },
          ],
          json_fields: {
            PRODUCT_NAME: "product",
            OLD_PRICE: "old_price",
            NEW_PRICE: "new_price",
            TYPE: "type",
            RECORDED_BY: "recordedby",
            RECORDED_ON: "recordedon",
          },
          json_meta: [
            [
              {
                key: "charset",
                value: "utf-8",
              },
            ],
          ],
    
        };
      },
      computed: {
             // MAP STATE
        ...mapState("notification", [
          "type",
          "message",
          "show",
          ]),
        ...mapGetters("products", ["Products", "SellingpriceChanges"]),
    
    
        /**
         * Total no. of records
         */
    
        rows() {
          return this.filteredReport ? this.filteredReport.length : 1;
        },
    
        /**
         * Todo list of records
         */
      },
      mounted() {
        // Set the initial number of items
        this.totalRows = this.SellingpriceChanges ? this.SellingpriceChanges.length : 1;
      },
      methods: {
        ...mapActions({
          FetchPriceChanges: "products/fetchPriceChanges",
          FetchProducts: "products/fetchProducts",
    
        }),
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },
        // COMMA SEPERATORS
        thousandSeperator(m) {
          if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
            return m
                .toString()
                .replace(/[^0-9.]+/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            return m;
          }
        },
        assiginData() {
            this.filteredReport = this.SellingpriceChanges;
        },
        filterReport() {
          let date2 = this.data.dateto;
          let date1 = this.data.datefrom;
          this.filteredReport = this.SellingpriceChanges.filter((element) => {
            if (this.data.product != "" && this.data.datefrom == "" && this.data.dateto != "") {
              this.Products.filter((element) => {
                if (element.id == this.data.product) {
                  let expcat = element.name;
                  this.filterTitle =
                    "Price Changes Report For " + expcat + " Up To " + this.data.dateto;
                }
              });
    
              return element.product_id == this.data.product && element.date <= date2;
            } else if (
              this.data.product == "" &&
              this.data.datefrom != "" &&
              this.data.dateto != ""
            ) {
              this.filterTitle =
                "Selling price changes report from " + this.data.datefrom + " To " + this.data.dateto;
              return element.date >= date1 && element.date <= date2;
            } else if (
              this.data.product != "" &&
              this.data.datefrom != "" &&
              this.data.dateto != ""
            ) {
              this.Products.filter((element) => {
                if (element.id == this.data.product) {
                  let expcatx = element.name;
                  this.filterTitle =
                    "Price Changes Report For " +
                    expcatx +
                    " From " +
                    this.data.datefrom +
                    " To " +
                    this.data.dateto;
                }
              });
    
              return (
                element.product_id == this.data.product &&
                element.date >= date1 &&
                element.date <= date2
              );
            }
          });
        },
      },      
      watch: {
        SellingpriceChanges(newValue){
          if(newValue){
            this.assiginData();
          }
        },
      },
      created() {
        this.FetchPriceChanges();
        this.FetchProducts();
        this.assiginData();
      },
    };
    </script>
    
    <template>
      <Layout>
        <PageHeader :title="title" :items="items" />
    
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-9">
                    <h3 class="card-title mb-2 text-center" v-html="filterTitle"></h3>
                  </div>
    
                </div>
                <div class="row">
                  <div class="col-md-3 mt-4">
                    <download-excel
                      class="btn btn-info"
                      :data="filteredReport"
                      :fields="json_fields"
                      :worksheet="'STOREPRICE CHANGES REPORT ON' + currentdate"
                      type="csv"
                      :name="'Store PriceChanges' + currentdate + '.xls'"
                    >
                      Export Excel <i class="fa fa-download"></i>
                    </download-excel>
                  </div>
                  <div class="col-md-3 form-group mb-2">
                    <label>FROM</label>
                    <input
                      @change="filterReport()"
                      type="date"
                      v-model="data.datefrom"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-3 form-group">
                    <label>TO</label>
                    <input
                      @change="filterReport()"
                      v-model="data.dateto"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div class="col-3">
                    <div class="form-group">
                      <label>Product</label>
                      <model-list-select
                        :list="Products ? Products : []"
                        v-model="data.product"
                        option-value="id"
                        option-text="name"
                        class="mb-3"
                        placeholder="Select Product"
                        @input="filterReport()"
                      >
                      </model-list-select>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                      class="datatables"
                      :items="filteredReport?filteredReport:[]"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                  </b-table>
                </div>
                <Loader  v-if="!filteredReport"/>
                <div class="row">
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </template>
    
    <style>
    .btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
    </style>
    